
/**
 * This filter applies a twist effect making display objects appear twisted in the given direction.
 *
 * @class
 * @extends PIXI.AbstractFilter
 * @memberof PIXI.filters
 */


import fragment from './twist.frag.glsl';

function TwistFilter()
{
    PIXI.AbstractFilter.call(this);

    this.uniforms = {
        radius:     { type: '1f', value: 1.0 },
        angle:      { type: '1f', value: 0.0 },
        offset:     { type: 'v2', value: { x: 0.5, y: 0.0 } }
    }
    
    this.fragmentSrc = fragment;
}

TwistFilter.prototype = Object.create(PIXI.AbstractFilter.prototype);
TwistFilter.prototype.constructor = TwistFilter;

Object.defineProperties(TwistFilter.prototype, {
    /**
     * This point describes the the offset of the twist.
     *
     * @member {PIXI.Point}
     * @memberof PIXI.filters.TwistFilter#
     */
    offset: {
        get: function ()
        {
            return this.uniforms.offset.value;
        },
        set: function (value)
        {
            this.uniforms.offset.value = value;
        }
    },

    /**
     * This radius of the twist.
     *
     * @member {number}
     * @memberof PIXI.filters.TwistFilter#
     */
    radius: {
        get: function ()
        {
            return this.uniforms.radius.value;
        },
        set: function (value)
        {
            this.uniforms.radius.value = value;
        }
    },

    /**
     * This angle of the twist.
     *
     * @member {number}
     * @memberof PIXI.filters.TwistFilter#
     */
    angle: {
        get: function ()
        {
            return this.uniforms.angle.value;
        },
        set: function (value)
        {
            this.uniforms.angle.value = value;
        }
    }
});




module.exports = TwistFilter;



/** WEBPACK FOOTER **
 ** ./src/js/controllers/filters/twistFilter.js
 **/